import localReferences from '@/helpers/localReferences';

const employerInfoMixin = {
    data() {
        return {
            localReferences,
            payrollInfoEmployerCalculateFields: [
                {
                    id: 'deals',
                    name: 'Сделки'
                },
                {
                    id: 'salary_cashless',
                    name: 'Оклад на карту'
                },
                {
                    id: 'salary_cash',
                    name: 'Оклад в руки'
                },
                {
                    id: 'prepayment',
                    name: 'Авансы'
                },
                {
                    id: 'bonus',
                    name: 'Премия'
                },
                {
                    id: 'fine',
                    name: 'Штраф'
                },
                {
                    id: 'efficiency_payment_manager',
                    name: 'Выполнение плана %'
                },
                {
                    id: 'efficiency_payment_measurer',
                    name: 'Заключаемость %'
                },
                {
                    id: 'debts_previous_periods',
                    name: 'Долги предыдущих периодов'
                }
            ]
        };
    },
    methods: {
        getName(obj, field) {
            if (Object.keys(obj).length !== 0) {
                if (Array.isArray(field)) {
                    return field.map(id => obj.find(item => item.id === id).name).join(', ');
                } else {
                    return obj.filter(item => item.id === field).map(item => item.name)[0];
                }
            }
        }
    }
};

export default employerInfoMixin;
